import { toastsAtom } from '@/global-store';
import { useSetAtom } from 'jotai';
import { useInlineTranslation } from '@/i18n/hooks/useInlineTranslation.tsx';

export function useNotification() {
  const { t } = useInlineTranslation();
  const setToasts = useSetAtom(toastsAtom);

  const show = (message, severity, duration) => {
    setToasts((prev) => {
      return [
        ...prev,
        {
          message: message || t('errorOccurred'),
          severity,
          key: new Date().getTime(),
          duration,
        },
      ];
    });
  };

  return {
    info(message, duration) {
      show(message, 'info', duration);
    },
    success(message, duration) {
      show(message, 'success', duration);
    },
    warning(message, duration) {
      show(message, 'warning', duration);
    },
    error(message, duration) {
      show(message, 'error', duration);
    },
  };
}
